import { createAnalyticsMiddleware, createAnalyticsReducer } from 'common/analytics'

const eventsMap = {}

export const analyticsMiddleware = createAnalyticsMiddleware(eventsMap)

export const analyticsReducer = createAnalyticsReducer(eventsMap)
